<template>
    <div>
        <container-page :headerHeight="'20%'" :bodyHeight="'100%'">
            <template v-slot:header>
                <div class="headerPage" v-if="!user.CLIENTE_ID">
                    <span class="titlePage"> {{'Projeto' | translate('Projeto')}} </span>
                </div>
                <div class="bodyPage" v-if="user.CLIENTE_ID">
                    <no-adm-banner message="Área destinada a usuários Operadores!"/>
                </div>
            </template>
            <template v-slot:body v-if="!user.CLIENTE_ID">
                <div style="padding:2em;">
                    <v-row>
                        <v-col cols="11">
                            <v-card
                                class="mx-auto"
                            >
                                <v-list style="padding:0;" v-if="clients.length">
                                    <v-list-item style="background-color: #d4d4d4;">
                                        <v-row>
                                            <v-col cols="8"><h2>{{'Clientes' | translate('Projeto')}}</h2></v-col>
                                            <v-col><h2>{{'Quantidade' | translate('Projeto')}}</h2></v-col>
                                            <v-col><h2>{{'Total de Horas' | translate('Projeto')}}</h2></v-col>
                                            <v-col style="min-width:48px !important; max-width:48px !important;"/>
                                        </v-row>
                                    </v-list-item>
                                    <v-divider/>
                                    <v-list-group
                                        v-for="client in clients" :key="client.ID"
                                        :value="false"
                                        style="border-bottom: 0.25px solid #e0e0e0;"
                                    >
                                        <template v-slot:activator>
                                            <v-row>
                                                <v-col cols="8">
                                                    <v-avatar size="40">
                                                        <img :src="client.IMAGEM_PERFIL ? baseUrl + client.IMAGEM_PERFIL: defaultImage">
                                                    </v-avatar>
                                                    <span style="margin-left: 10px;">{{client.NOME}}</span>
                                                </v-col>
                                                <v-col></v-col>
                                                <v-col></v-col>
                                            </v-row>
                                        </template>
                                        <v-card elevation="24" v-if="!loading" style="margin: 2em 0em 2em 2em">
                                            <v-list style="padding:0;">
                                                <v-list-item style="background-color: #d4d4d4;">
                                                    <v-row>
                                                        <v-col cols="2"><h2>{{'Projetos' | translate('Projeto')}}</h2></v-col>
                                                        <v-col><h2>{{'RA' | translate('Projeto')}}</h2></v-col>
                                                        <v-col><h2>{{'Data' | translate('Projeto')}}</h2></v-col>
                                                        <v-col><h2>{{'Progresso' | translate('Projeto')}}</h2></v-col>
                                                        <v-col><h2>{{'Total de Horas' | translate('Projeto')}}</h2></v-col>
                                                        <v-col><h2>{{'Tempo Utilizado' | translate('Projeto')}}</h2></v-col>
                                                        <v-col><h2>{{'Pessoa' | translate('Projeto')}}</h2></v-col>
                                                        <v-col style="min-width:48px !important; max-width:48px !important;"/>
                                                    </v-row>
                                                </v-list-item>
                                                <v-divider/>
                                                <v-list-group
                                                    v-for="project in client.projects"
                                                    :key="project.ID"
                                                    :value="false"
                                                    style="border-bottom: 0.25px solid #e0e0e0;"
                                                >
                                                    <template v-slot:activator>
                                                        <v-row>
                                                            <v-col cols="2">{{project.ASSUNTO}}</v-col>
                                                            <v-col>{{project.ID}}</v-col>
                                                            <v-col>{{'Data' | translate('Projeto')}}</v-col>
                                                            <v-col>{{'Progresso' | translate('Projeto')}}</v-col>
                                                            <v-col>{{'Total de Horas' | translate('Projeto')}}</v-col>
                                                            <v-col>{{'Tempo Utilizado' | translate('Projeto')}}</v-col>
                                                            <v-col></v-col>
                                                        </v-row>
                                                    </template>
                                                    <v-card v-if="project.tasks" elevation="24" style="margin: 2em 0em 2em 2em">
                                                        <v-list style="padding:0;">
                                                            <v-list-item style="background-color: #d4d4d4;">
                                                                <v-row>
                                                                    <v-col cols="2"><h2>{{'Tarefas' | translate('Projeto')}}</h2></v-col>
                                                                    <v-col><h2>{{'RA' | translate('Projeto')}}</h2></v-col>
                                                                    <v-col><h2>{{'Data' | translate('Projeto')}}</h2></v-col>
                                                                    <v-col><h2>{{'Progresso' | translate('Projeto')}}</h2></v-col>
                                                                    <v-col><h2>{{'Total de Horas' | translate('Projeto')}}</h2></v-col>
                                                                    <v-col><h2>{{'Tempo Utilizado' | translate('Projeto')}}</h2></v-col>
                                                                    <v-col><h2>{{'Pessoa' | translate('Projeto')}}</h2></v-col>
                                                                    <v-col style="min-width:48px !important; max-width:48px !important;"/>
                                                                </v-row>
                                                            </v-list-item>
                                                            <v-divider/>
                                                            <v-list-group
                                                                v-for="task in project.tasks"
                                                                :key="task.ID"
                                                                :value="false"
                                                                style="border-bottom: 0.25px solid #e0e0e0;"
                                                            >
                                                                <template v-slot:activator>
                                                                    <v-row>
                                                                        <v-col cols="2">{{task.ASSUNTO}}</v-col>
                                                                        <v-col>{{task.ID}}</v-col>
                                                                        <v-col>{{'Data' | translate('Projeto')}}</v-col>
                                                                        <v-col>{{'Progresso' | translate('Projeto')}}</v-col>
                                                                        <v-col>{{'Total de Horas' | translate('Projeto')}}</v-col>
                                                                        <v-col>{{'Tempo Utilizado' | translate('Projeto')}}</v-col>
                                                                        <v-col></v-col>
                                                                    </v-row>
                                                                </template>
                                                                <v-card v-if="task.tasks" elevation="24" style="margin: 2em 0em 2em 2em">
                                                                    <v-list style="padding:0;">
                                                                        <v-list-item style="background-color: #d4d4d4;">
                                                                            <v-row>
                                                                                <v-col cols="2"><h2>{{'Tarefas' | translate('Projeto')}}</h2></v-col>
                                                                                <v-col><h2>{{'RA' | translate('Projeto')}}</h2></v-col>
                                                                                <v-col><h2>{{'Data' | translate('Projeto')}}</h2></v-col>
                                                                                <v-col><h2>{{'Progresso' | translate('Projeto')}}</h2></v-col>
                                                                                <v-col><h2>{{'Total de Horas' | translate('Projeto')}}</h2></v-col>
                                                                                <v-col><h2>{{'Tempo Utilizado' | translate('Projeto')}}</h2></v-col>
                                                                                <v-col><h2>{{'Pessoa' | translate('Projeto')}}</h2></v-col>
                                                                                <v-col style="min-width:48px !important; max-width:48px !important;"/>
                                                                            </v-row>
                                                                        </v-list-item>
                                                                        <v-divider/>
                                                                        <v-list-group
                                                                            v-for="subTask in task.tasks"
                                                                            :key="subTask.ID"
                                                                            :value="false"
                                                                            style="border-bottom: 0.25px solid #e0e0e0;"
                                                                        >
                                                                            <template v-slot:activator>
                                                                                <v-row>
                                                                                    <v-col cols="2">{{subTask.ASSUNTO}}</v-col>
                                                                                    <v-col>{{subTask.ID}}</v-col>
                                                                                    <v-col>{{'Data' | translate('Projeto')}}</v-col>
                                                                                    <v-col>{{'Progresso' | translate('Projeto')}}</v-col>
                                                                                    <v-col>{{'Total de Horas' | translate('Projeto')}}</v-col>
                                                                                    <v-col>{{'Tempo Utilizado' | translate('Projeto')}}</v-col>
                                                                                    <v-col></v-col>
                                                                                </v-row>
                                                                            </template>

                                                                            <v-divider/>
                                                                        </v-list-group>
                                                                        <v-list-item>
                                                                            <span> {{labels.adicionar}} ...</span>
                                                                            <v-spacer/>
                                                                            <v-btn icon @click="addTask(task)">
                                                                                <v-icon>
                                                                                    mdi-plus-circle
                                                                                </v-icon>
                                                                            </v-btn>
                                                                        </v-list-item>
                                                                    </v-list>
                                                                </v-card>
                                                                <v-divider/>
                                                            </v-list-group>
                                                            <v-list-item>
                                                                <span> {{labels.adicionar}} ...</span>
                                                                <v-spacer/>
                                                                <v-btn icon @click="addTask(project)">
                                                                    <v-icon>
                                                                        mdi-plus-circle
                                                                    </v-icon>
                                                                </v-btn>
                                                            </v-list-item>
                                                        </v-list>
                                                    </v-card>
                                                    <v-divider/>
                                                </v-list-group>
                                                <v-list-item>
                                                    <span> {{labels.adicionar}} ...</span>
                                                    <v-spacer/>
                                                    <v-btn icon @click="openAddProject(client)">
                                                        <v-icon>
                                                            mdi-plus-circle
                                                        </v-icon>
                                                    </v-btn>
                                                </v-list-item>
                                            </v-list>
                                        </v-card>
                                        <v-divider/>
                                    </v-list-group>
                                </v-list>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>
            </template>
        </container-page>
        <v-dialog
            v-model="projectDialog" 
            class="mx-auto"
            max-width="800"   
        >
            <v-card>
                <v-card-title>{{'Cadastro de Projeto' | translate('Projeto')}}</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="bodyCallLink">
                    <v-row>
                        <v-col>
                            <v-combobox
                                dense
                                v-model="editItem.client"
                                :items="clientUsers"
                                :label="labels.pessoas"
                                item-text="NOME"
                                return-object
                                hide-selected
                                chips
                                :menu-props="{closeOnContentClick:true}"
                            >
                                <template v-slot:selection="{ attrs, item, parent, selected }">
                                    <v-chip
                                        :key="JSON.stringify(item.ID)"
                                        v-if="item === Object(item)"
                                        v-bind="attrs"
                                        :input-value="selected.value"
                                        @click:close="parent.selectItem(item.value)"
                                        class="kndChip"
                                    >
                                        <v-avatar 
                                            size="22"
                                            style="margin-right:5px;"  
                                        >
                                            <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                        </v-avatar>
                                        <span class="pr-2">
                                            {{ item.NOME }}
                                        </span>
                                        <v-btn
                                            icon
                                            @click="parent.selectItem(item)"
                                            :disabled="item == call.responsible"
                                        >
                                            <v-icon color="red">
                                                mdi-close-circle
                                            </v-icon>
                                        </v-btn>
                                    </v-chip>
                                </template>
                                <template v-slot:[`item`]="{ item }">
                                    <v-avatar 
                                        v-if="item.EMAIL"
                                        size="22" 
                                        style="margin-right:5px;"  
                                    >
                                        <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                    </v-avatar>
                                    <span v-if="item.EMAIL" class="pr-2">
                                        {{ item.NOME }}
                                    </span>
                                </template>
                                <template v-slot:append-item>
                                    <v-row>
                                        <v-col class="noPaddingCol">
                                            <v-btn 
                                                plain 
                                                style="width: inherit;" 
                                                @click="addUser('responsible')"
                                            >
                                                <v-icon color="#1976d2">
                                                    mdi-account-plus-outline
                                                </v-icon>
                                                <span style="margin-left:4px; color: #1976d2; font-weight: bolder;">{{'Responsável' | translate('Atendimento')}}</span>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-combobox>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        class="white--text btn1" 
                        small
                        color="black"
                        @click="projectDialog = false"
                    >
                        <v-icon x-small>
                            mdi-close
                        </v-icon>
                        {{'Calcelar' | translate('Projeto')}}
                    </v-btn>
                    <v-btn
                        class="white--text btn1" 
                        small
                        color="black"
                        @click="addProject()"
                    >
                        <v-icon x-small>
                            mdi-check
                        </v-icon>
                        {{'Ok' | translate('Projeto')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import ContainerPage from '../../../src/components/containerPage.vue'
import loadAllClientsByCompanyId from '../../../src/app/cliente/loadAll'
import translate from '../../../src/plugins/translate'
import loadAllRequesters from '../../../src/app/solicitanteAtendimento/loadAllRequesters'
import NoAdmBanner from '../../../src/components/NoAdmBanner'


const user = createNamespacedHelpers('user')

export default {
    name: 'Projeto',
    components: {ContainerPage, NoAdmBanner},
    data() {
        return {
            loading: false,
            clients: [],
            defaultImage: require('../../../src/assets/user.png'),
            baseUrl: process.env.VUE_APP_API_URL,
            labels:{
                adicionar: translate('Adicionar', 'Projeto'),
                pessoas: translate('Pessoas', 'Projeto'),
                
            },
            editItem:{},
            projectDialog: false,
            projectDialogLoading: false,
            clientUsers: []
        }
    },
    computed:{
        ...user.mapGetters(['user'])
    },
    methods: {
        async getAllClients(){
            this.loading = true
            await loadAllClientsByCompanyId(this.user.EMPRESA_ID)
                .then(function(response){
                    this.clients = response.data
                    this.clients[0].projects = []
                    this.clients[0].projects.push({ID:1, ASSUNTO:'teste', tasks:[{ID:31, ASSUNTO:'TESTE 2'},{ID:2, ASSUNTO:'TESTE 3', tasks:[{ID:3, ASSUNTO:'TESTE 4'}]}]})
                }.bind(this))
                .finally(this.loading = false)
        },
        async openAddProject(client){
            this.selectedClient = client
            this.projectDialogLoading = true
            await loadAllRequesters({companyId:this.user.EMPRESA_ID, clientId: client.ID}).then(function(response){
                this.clientUsers = response.data
                this.projectDialogLoading = false
            }.bind(this))
            this.projectDialog = true
        },
        addProject(){
            this.loading = true
            setTimeout(function(){
                if(!this.selectedClient.projects) this.selectedClient.projects = []
                this.selectedClient.projects.push({ID:1, ASSUNTO:'teste', tasks:[{ID:28, ASSUNTO:'TESTE 2'},{ID:2, ASSUNTO:'TESTE 3', tasks:[{ID:99, ASSUNTO:'TESTE 4'}]}]})
                this.loading = false
            }.bind(this),10)
            this.projectDialog = false
        },
        addTask(task){
            this.loading = true
            setTimeout(function(){
                if(!task.tasks) task.tasks = []
                task.tasks.push({ID:1, ASSUNTO:'teste', tasks:[{ID:57, ASSUNTO:'TESTE 2'},{ID:2, ASSUNTO:'TESTE 3', tasks:[{ID:85, ASSUNTO:'TESTE 4'}]}]})
                this.loading = false
            }.bind(this),10)
        }
    },
    async mounted() {
        await this.getAllClients()
    }

}
</script>
<style scoped>
.titlePage{
    font-size: 20px;
    font-weight: 700;
}
</style>
